import { Button, Divider } from "@mui/material";
import UpdateOutlinedIcon from '@mui/icons-material/UpdateOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import {useState} from 'react';

import AddTransactionModal from "../components/AddTransactionModal"
import TransactionSummary from "../components/transactionSummary";
import { useGetPeriodQuery } from "../../../../../services/PaymentToolApi";
import { getPeriodStatusComp } from "../../../../../utils";
import DebounceInput from "../../../../../components/DebounceInput";


const PaymentByUserHeader = ({selectedYear, selectedPeriod, selectedUser, search, setSearch}) => {

  const { data: period, isLoading: periodIsLoading, isFetching: periodIsFetching, error: periodError } = useGetPeriodQuery({period: selectedPeriod});

  const [newTransactionModalIsOpen, setNewTransactionModalIsOpen] = useState(false);

  const TableHeaderInfo = {
    padding: '1em',
    margin: '0 0 1px 0',
    borderRadius: '1em 1em 0 0',
    backgroundColor: 'white',
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between'
  }

  if (periodIsLoading || periodIsFetching) return <p>Loading...</p>;
  if (periodError) return <p>Error! {periodError}</p>;

  if(!period) return <p>Loading ...</p>

  function handleSearchChange(value) {
    setSearch(value);
  }

  return (
    <div style={TableHeaderInfo} >

      <div style={{ margin: '0 1em 0 0' }} >

        <div style={{ display: 'flex', flexWrap: 'nowrap', margin: '0 0 1em 0' }} >
          <p style={{ fontWeight: '600', margin: '0 0.5em 0 0', whiteSpace: 'nowrap' }} >Displayed Period:</p>
          <p style={{ whiteSpace: 'nowrap' }} >{selectedPeriod}</p>
        </div>

        <div style={{ display: 'flex', flexWrap: 'nowrap' }} >
          <p style={{ fontWeight: '600', margin: '0 0.5em 0 0', whiteSpace: 'nowrap' }} >Status:</p>
          <p style={{ whiteSpace: 'nowrap', fontWeight: '600', }} >{ getPeriodStatusComp(period) }</p>
          {/* Status can be 'Current', 'Pending', or 'Completed' */}
        </div>

      </div>

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }} >

        <div style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'flex-end', justifyContent: 'space-between', width: '100%' }} >

          <div style={{ display: 'flex', flexWrap: 'nowrap', margin: '0 0 0.5em 0' }} >
            <p style={{ fontWeight: '600', margin: '0 0.5em 0 0', whiteSpace: 'nowrap' }} >Displayed User:</p>
            <p style={{ whiteSpace: 'nowrap' }} >{selectedUser.fullName}</p>
          </div>

          <div style={{display: 'flex', width: '100%', margin: '0 0 0 2em', alignItems: 'center'}}>
            <div style={{ width: '100%', margin: '0 2em 0 0' }}>
              <DebounceInput
                sx={{ width: '100%'}}
                defaultValue={""}
                placeholder="Search..."
                debounceTimeout={500}
                handleDebounce={handleSearchChange}
              />
            </div>

            <div style={{ display: 'flex', flexWrap: 'nowrap', margin: '0 0 0.5em 0' }} >
              {/* here we need to have a search bar for the table */}
              <Button disabled={periodIsLoading || periodError} onClick={()=> setNewTransactionModalIsOpen(true)} variant="contained" size="small" startIcon={<AddOutlinedIcon />} sx={{ margin: '0 1em 0 0', height: '28px', minWidth: '100px' }}>
                ADD
              </Button>
            </div>
          </div>

        </div>

        <TransactionSummary selectedYear={selectedYear} selectedPeriod={selectedPeriod} userID={selectedUser.id}/>


      </div>

      {
        newTransactionModalIsOpen &&
        <AddTransactionModal period={period} selectedUser={selectedUser} modalIsOpen={newTransactionModalIsOpen} setModalIsOpen={setNewTransactionModalIsOpen}/>
      }



    </div>
  );
}

export default PaymentByUserHeader;